import React, { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { bothSidescroll } from "../../../Constant";
import HeaderCard from "../../Common/HeaderCard";
import ScrollBar from "react-perfect-scrollbar";

const BothSideScroll = () => {
  return (
    <Fragment>
      <Col sm="6">
        <Card>
          <HeaderCard title={bothSidescroll} />
          <CardBody>
            <div className="scroll-bar-wrap">
              <ScrollBar className="both-side-scroll scroll-demo p-0" style={{ width: "100%", height: 300 }}>
                <Image src={require("../../../assets/images/banner/1.jpg")} alt="" width={800} height={600} />
              </ScrollBar>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default BothSideScroll;
